import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Popup } from 'components/Popup'
import { useFinancialsPopup } from 'features/Financials/Providers/FinancialsPopupProvider'
import { useFinancialsCognusARContext } from 'features/Financials/Providers/FinancialsCognusARProvider'
import { TRebatesTableType } from 'features/Financials/Rebates/RebatesTable/types'
import { FINANCIAL_TABS } from 'features/Financials/constants'
import { InvoicesTable } from './InvoicesTable'
import { getUser } from 'redux/store/user/getters'
import { getUserCommunity } from 'helper/common'
import { InvoicesDetailsGeneral } from 'features/Financials/Rebates/RebatesTable/InvoicesDetailsPopup/InvoicesDetails/InvoicesDetailsGeneral'
import useRouter from 'hooks/useRouter'
import { routes } from 'router'

export const InvoicesDetailsPopup = () => {
  const {
    invoicesDetailsPopup: { state, actions }
  } = useFinancialsPopup()
  const { invoiceData } = state.payload
  const { query, navigate } = useRouter()
  const {
    state: { tableData, canSeeInvoicesDetailsOnMarketplaceAR }
  } = useFinancialsCognusARContext()

  const user = useSelector(getUser)

  useEffect(() => {
    if (!query?.invoiceId || !canSeeInvoicesDetailsOnMarketplaceAR) return

    const invoiceFromQuery = tableData.find(
      (row) => row.uuid === query.invoiceId
    )
    if (!invoiceFromQuery) return

    actions.open({ invoiceData: invoiceFromQuery })
    navigate(`${routes.financials}/${FINANCIAL_TABS[2].key}`, { replace: true })
  }, [
    actions,
    canSeeInvoicesDetailsOnMarketplaceAR,
    navigate,
    query?.invoiceId,
    tableData
  ])

  const showHSName = useMemo(() => Boolean(user.vendor || user.commons), [user])

  const showVendor = useMemo(
    () => Boolean(getUserCommunity(user) || user.commons),
    [user]
  )

  return (
    <Popup {...state} width={1142} footer={null}>
      <div className="invoices-details">
        {invoiceData?.uuid && (
          <div className="column gap-32">
            <InvoicesDetailsGeneral
              showHSName={showHSName}
              showVendor={showVendor}
              invoiceData={
                {
                  ...invoiceData,
                  supplier_name: invoiceData.supplier,
                  health_system_name: invoiceData.health_system,
                  hospital_name: ''
                } as unknown as TRebatesTableType
              }
            />
            <InvoicesTable />
          </div>
        )}
      </div>
    </Popup>
  )
}
